var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first_article",style:({
	borderBottom: _vm.border?'0.0625rem solid rgba(228, 65, 0, 0.3)':''
})},[_c('div',{staticClass:"first_title line-1",on:{"click":_vm.goDetail}},[_vm._v(_vm._s(_vm.text.title || '-'))]),(_vm.hasSub)?_c('div',{staticClass:"first_sub line-2",domProps:{"innerHTML":_vm._s(_vm.text.subTitle)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }